<template>
  <div id="maps" class="my-2">
    <b-container v-if="isLoading">
      <b-row style="height: 350px" class="mb-5" align-v="center">
        <b-col class="text-center">
          <spinner type="grow" variant="default"></spinner>
        </b-col>
      </b-row>
    </b-container>
    <b-row>
      <b-col
        v-for="(municipio, id) in paginate.data"
        v-bind:key="id"
        v-if="!isLoading"
        :lg="collumsSize()"
        :md="collumsSize()"
        sm="6"
      >
        <a :href="urlLogin(municipio.url)"
           :target="urlTarget(municipio.url)"
           @click="setLatest(municipio)"
        >
          <b-card
            border-variant="dark"
            no-body
            :id="'card-'+municipio.codigo_ibge"
            :class="[latestClicked && latestClicked.codigo_ibge === municipio.codigo_ibge ? 'latest-clicked' : '']"
            text-variant="black"
            class="mt-2 p-3 h6 card-municipio"
          >
            <b-card-text class="text-center">
               {{ municipio.nome }}
            </b-card-text>
          </b-card>
        </a>
      </b-col>
    </b-row>
    <div v-if="!isLoading && municipiosFilteredsCount === 0 && !error" class="container">
      <div class="row justify-content-md-center">
        <div class="d-flex align-items-center">
          <h2 class="text-muted">
            Município não encontrado :(
          </h2>
        </div>
      </div>
    </div>
    <div v-if="!isLoading && municipiosFilteredsCount > 0 && !error">
      <div class="d-flex mt-2 justify-content-center">
        Exibindo página:
        {{ paginate.currentPage }}
        no total de:
        {{ paginate.totalPages }}
        páginas e
        {{ paginate.total }}
        municípios
      </div>
      <div class="mt-2 mb-0 text-center">
        <b-pagination
          size="sm"
          v-model="paginate.currentPage"
          :per-page="paginate.perPage"
          :total-rows="paginate.total"
          align="center"
          class="mb-1"
        />
      </div>
    </div>
    <b-container v-if="error">
      <b-row style="height: 350px" class="mb-5" align-v="center">
        <b-col class="text-center">
            <h5 class="text-muted">Não foi possível carregar os municípios</h5>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import {mapActions, mapGetters, mapState} from 'vuex'
import Spinner from '../../components/Spinner'
import store from './store/index'
import * as mutations from './store/mutations.type'
const Paginate = require('paginate-array')

export default {
  name: 'GridLocations',
  components: {Spinner},
  props: {
    perPage: {
      default: 12,
      type: Number
    },
    collums: {
        default: 3,
        type: Number
    }
  },
  data() {
    return {
      paginate: {
        data: [],
        currentPage: 1,
        totalPages: 1,
        total: 1
      }
    };
  },
  computed: {
    ...mapGetters(['municipiosFiltereds', 'municipiosFilteredsCount', 'latestClicked']),
    ...mapState(['isLoading' , 'error'])
  },
  watch: {
    isLoading: function(val) {
      if (val === false) {
        this.toPage();
      }
    },
    municipiosFiltereds: function() {
      this.toPage(1);
    },
    latestClicked: function (value) {
      document.getElementById('card-'+value.codigo_ibge).classList.remove('latest-clicked');
    },
    'paginate.currentPage': function(page) {
      this.toPage(page);
    }
  },
  created() {
    this.bootstrap();
  },
  methods: {
    ...mapActions(['loadMunicipios', 'loadEstados']),
    setLatest: function(municipio){
      store.commit(mutations.setLatest , municipio)
      document.getElementById('card-'+municipio.codigo_ibge).classList.add('latest-clicked');
    },
    bootstrap: function() {
      this.loadMunicipios();
    },
    toPage: function(page = 1) {
      const self = this;
      self.paginate = Paginate(self.municipiosFiltereds, page, this.perPage);
    },
    urlLogin: function (url) {
      return `${process.env.VUE_APP_PROGRAMA_JANELAUNICA_URI}/?${url.split('?')[1]}`
    },
    urlTarget: function (url) {
      return (url === '#') ? '_self' : '_blanck'
    },
    collumsSize(){
      if (this.collums === 3){
          return 4
      }
      if (this.collums === 4){
          return 3
      }
    }
  }
};
</script>

<style lang="scss">

  .card-municipio {
    color: #323232 !important;
    background: #f4f5f7 !important;
  }

  .latest-clicked {
    color: #fff !important;
    background: #172b4d !important;
  }

  .card-municipio:hover {
    color: #fff !important;
    background: #000 !important;
  }

  .latest-clicked:hover {
    color: #fff !important;
    background: #000 !important;
  }

  .latest-clicked .img-malha {
    -webkit-filter: invert(100%) !important;
  }

  .latest-clicked:hover .img-malha {
    -webkit-filter: invert(100%) !important;
  }

  .card-municipio .img-malha {
     -webkit-filter: invert(0%);
  }

  .card-municipio:hover .img-malha {
    -webkit-filter: invert(100%);
  }

</style>
